import { format } from 'date-fns';

export const formatFullDate = (date: string | Date | number): string =>
  format(new Date(date), 'dd.MM.yyyy HH:mm');
